module.exports = __webpack_public_path__ + "img/img1.a3d0f1b6.png";